module.exports = __webpack_public_path__ + "img/7.decfd3fc.png";